import { z } from 'zod';

export const LocationAttachmentSchema = z.object({
    id: z.string().uuid(),
    url: z.string(),
    originalUrl: z.string(),
    fileName: z.string(),
    uploadedAt: z.coerce.date(),
    mimeType: z.string(),
});

export type LocationAttachment = z.infer<typeof LocationAttachmentSchema>;
